// components
import Menu from "../components/Menu";
import Footer from "../components/Footer.jsx";

const Layout = ({children}) => {
  return (
    <>
      <Menu/>
       {children}
      <Footer/>
    </>
  );
};

export default Layout;
